module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_plan_show_bg_02-c781d2efc6cc9ea8a70660a25204d3e0.jpg";